import isNil from "lodash/fp/isNil";

class Controller {
  constructor(Events, $stateParams, Sections, $injector, Lists) {
    "ngInject";

    this.Lists = Lists;
    this.Events = Events;
    this.$injector = $injector;
    this.$stateParams = $stateParams;

    this.sections = Sections.settingsSections;
    this.page = this.$stateParams.page;
    this.limit = this.$stateParams.limit;
    this.activeParams = this.$stateParams;

    this.errorNotificationEvent = this.Events.eventsType.onShowErrorNotification;
    this.addItemEvent = this.Events.getAddEvent("promotions");
    this.filterEvent = this.Events.getFilterEvent("promotions");
    this.paginateEvent = this.Events.getPaginateEvent("promotions");
    this.sortEvent = this.Events.getSortEvent("promotions");

    this.resourceParams = { isCityRequired: false };

    // Get ride category per city
    this.City = $injector.get("City");
    this.CityHandler = this.$injector.get("CityHandler");
    this.dashboardCity = this.CityHandler.get();
    this.getRideCategoriesEvent = this.Events.getUpdateEvent(
      "getRideCategories"
    );
  }
  $onInit() {
    this.getRideCategory(this.dashboardCity);
  }
  getRideCategory(city) {
    const param = {};
    if (!isNil(city)) {
      param.city = city._id;
    }
    this.Lists.all.rideCategoryList = [];
    this.City.getRideCategory(param)
      .$promise.then((response) => {
        if (response.hits) {
          this.Lists.all.rideCategoryList = response.hits.map(
            ({ _id: name, _source: category }) => ({
              name,
              title: `${category.ride_type} ${category.service_type}`,
              param: "category",
            })
          );
        }
      })
      .catch((err) => {
        this.Events.emit(this.errorNotificationEvent, err.data);
      });
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/promotions/promotions.controller.js